import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PiUserCircleThin } from 'react-icons/pi';
import { AiOutlinePoweroff } from 'react-icons/ai';
import { RiArrowDropDownLine } from "react-icons/ri";
import ResponsiveSideBar from "./ResponsiveSidebar";
function TopNavbar() {
    const navigate = useNavigate();
    const userRole = localStorage.getItem('userRole');
    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        localStorage.removeItem('NewaccessToken');
        localStorage.removeItem('userRole');
        navigate('/login');
    };

    return (
        <>
            <div >
                
                <div className="app-top-navbar__right">
                    <div className="mobile-only-button">
                        <ResponsiveSideBar />
                    </div>
                    
                    <div className="app-sidebar-logo navbar-logo">
                        <img src="https://www.svgrepo.com//show/59753/team-leader.svg" alt="Logo" />
                        <h3>YOUR <span>LEADER</span></h3>
                    </div>
                    <ul className="app-top-navbar__right--list">
                        <li className="app-top-navbar__right--listitem" style={{paddingRight:"10px"}}>
                            <div className="userrole-class" onClick={handleOpenMenu}>
                                <PiUserCircleThin /> 
                                <span>{userRole}</span>
                                <span className="arrow-svg"> <RiArrowDropDownLine/></span>
                            </div>
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleCloseMenu}
                            >
                                <MenuItem className="logout-nav" onClick={handleLogout}>
                                    <AiOutlinePoweroff /> Logout
                                </MenuItem>
                            </Menu>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}

export default TopNavbar;
